
import { ResizableBase } from './ResizableBase';
import { ISeriesGroup } from './ISeriesGroup';
import { ISeries } from './series/ISeries';

export class SeriesGroup extends ResizableBase implements ISeriesGroup {
    constructor(container: d3.Selection<any>, clipPathId: string) {
        super(container, 'series-group');
        try {
            this.group().style({
                'clip-path': 'url(#' + clipPathId + ')'
            });
        } catch (e) {
            console.error(e);
        }
    }

    resizeFunction() {
        const self = this;
        return (w, h) => {
            self.resize(w, h, self);
        };
    }

    update(series: ISeries[]): void {
    }
}